import React, { useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { UncontrolledTooltip } from 'reactstrap'
import NotesHistory from '../../../Material/NotesHistory/NotesHistory'
import { toGlobalId } from './helpers'

// Driver-level billing notes (Driver.weekly_billing_notes), mirroring the
// "Billing Notes" column on the old collections page. The shared NotesHistory
// popover does the reading/writing: it saves through
// updateDriver(input: { id, weeklyBillingNotes }), which appends a
// DriverNotesHistory row of type "Billing" on the backend.
export default function BillingNotesCell({ caseId, driverId, notes }) {
    const [open, setOpen] = useState(false)
    const client = useApolloClient()

    const targetId = `cd-billing-notes-${caseId}`
    // NotesHistory feeds driverId straight into driverNotesHistory(driverId: ID!),
    // which expects a Relay global id — the case node only exposes the raw pk.
    const driverGid = toGlobalId('DriverNode', driverId)

    return (
        <span className="cd-billing-notes" onClick={(e) => e.stopPropagation()}>
            <small id={targetId} className="cd-billing-notes-text">
                {notes || '—'}
            </small>
            {notes && (
                <UncontrolledTooltip placement="left" target={targetId}>
                    {notes}
                </UncontrolledTooltip>
            )}
            <i
                className="fa fa-pencil-square-o cd-billing-notes-edit"
                title="Edit billing notes"
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen(true)
                }}
            />
            {open && driverGid && (
                <NotesHistory
                    driverId={driverGid}
                    target={targetId}
                    placement="left"
                    noteType="BILLING"
                    title="Billing Notes History"
                    name="weeklyBillingNotes"
                    objectType="driverNotes"
                    open={open}
                    handleClose={() => setOpen(false)}
                    // Required: NotesHistory calls this unconditionally after a save.
                    // Refetching the list query updates this cell in place.
                    refetchQuery={() =>
                        client.refetchQueries({ include: ['AllCollectionCases'] })
                    }
                />
            )}
        </span>
    )
}
